import React from "react";
import PropTypes from "prop-types";

import Backdrop from "Components/Common/Backdrop";

import { useApplicationDetailQuery } from "apis/ApplicationRequestDetail";
import ViewPowerApplicationModal from "./ViewPowerApplicationModal";

const ApplicationViewModal = ({ applicationId, handleClose }) => {
  const {
    data: {
      data: { applicationType: { id: applicationTypeId } = {} } = {},
    } = {},
    isLoading,
    isFetching,
  } = useApplicationDetailQuery(applicationId);

  if (isLoading || isFetching) {
    return <Backdrop open />;
  }

  return (
    <>
      {!!applicationTypeId && !!applicationId && (
        <ViewPowerApplicationModal
          isOpen={!!applicationId}
          handleClose={handleClose}
          applicationId={applicationId}
        />
      )}
    </>
  );
};

ApplicationViewModal.propTypes = {
  applicationId: PropTypes.string,
  handleClose: PropTypes.func,
};

export default ApplicationViewModal;
